import React from 'react'
import { Organization } from '../../api/organizations'
import { organizationTypeThemeNames } from '../../hooks/use-theme-switcher'
import { useOrganizationsCountQuery } from '../../queries/organizations'
import { DashboardCard, DashboardCardProps } from './dashboard-card'

const labels: { [key in Organization['type']]: Pick<DashboardCardProps, 'title' | 'mainStat'> } = {
  employer: {
    title: 'EMPLOYEURS',
    mainStat: {
      label: 'Employeurs',
      value: 0,
    },
  },
  interimAgency: {
    title: "AGENCES D'INTÉRIM",
    mainStat: {
      label: 'Agences',
      value: 0,
    },
  },
}

export const OrganizationsDashBoardCard: React.FC<{ type: Organization['type'] }> = ({ type }) => {
  const organizationsQuery = useOrganizationsCountQuery({
    populate: [''],
    fields: ['_id', 'type'],
    type: type,
  })
  return (
    <>
      <DashboardCard
        title={labels[type].title}
        mainStat={{ value: organizationsQuery.data ?? 0, label: labels[type].mainStat.label }}
        color={organizationTypeThemeNames[type]}
        queryStatus={organizationsQuery.status}
      />
    </>
  )
}
